import { gql } from '@apollo/client';

import { REPORT_COMMON_FIELDS } from '../fragments/reportCommonFields';
import { STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS } from '../fragments/standardDeliveryDeviceHigherCategoryReportFilters';

export const GET_STANDARD_DELIVERY_DHC_REPORT = gql`
    query GetStandardDeliveryDeviceHigherCategoryReport($id: ID!) {
        getStandardDeliveryDeviceHigherCategoryReport(id: $id) {
            ...reportCommonFields
            filters {
                ...standardDeliveryDeviceHigherCategoryReportFilters
                campaigns {
                    id
                    name
                }
            }
        }
    }
    ${REPORT_COMMON_FIELDS},
    ${STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS}
`;
